var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(!_vm.$auth.ready())?_c('div',[_vm._v("Site loading...")]):_vm._e(),(_vm.$auth.ready() && !_vm.$auth.check())?_c('layout-welcome'):_vm._e(),(_vm.$auth.ready() && _vm.$auth.check())?_c('layout-main'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }